<template>
  <div class="the-nav">
    <div class="logo">
      <auth-img class="logo-img" src="@/assets/img/logo-big.png" />
      <!-- <auth-img v-else class="logo-img" src="@/assets/img/logo-mini.png" /> -->
    </div>
    <a-menu @click="handleMenu" class="menu" mode="inline" v-model:selectedKeys="activePath">
      <a-menu-item key="/workplace">
        <template #icon>
          <div>
            <a-badge
              :dot="hasDot"
              style="width: 12px; height: 12px; position: absolute; top: 6px; left: 14px"
            ></a-badge>
            <AppstoreOutlined class="icon" />
          </div>
        </template>
        <span>工作台</span>
      </a-menu-item>
      <a-sub-menu>
        <template #icon><ClockCircleOutlined class="icon" /></template>
        <template #title>工单管理</template>
        <a-menu-item key="/todo">工单记录</a-menu-item>
        <a-menu-item key="/satisfaction">满意度评价</a-menu-item>
        <a-menu-item key="/bdWorkorder">BD工单</a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <template #icon><UserDeleteOutlined class="icon" /></template>
        <template #title>用户池</template>
        <a-menu-item key="/helper">医助-BD池</a-menu-item>
        <a-menu-item key="/doctor">医生池</a-menu-item>
        <a-menu-item key="/patient">患者池</a-menu-item>
        <a-menu-item key="/activeRevisit">主动回访</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/preliminaryMedicalRecord">
        <ContainerOutlined class="icon" />
        <span>预病历</span>
      </a-menu-item>
      <a-menu-item key="/callLog">
        <PhoneOutlined class="icon" />
        <span>通话记录</span>
        <a-badge :dot="hasunProcesslDot"></a-badge>
      </a-menu-item>
      <a-menu-item key="/SMSLog">
        <CommentOutlined />
        <span>短信记录</span>
      </a-menu-item>
      <a-menu-item key="/excellentCase">
        <ContainerOutlined class="icon" />
        <span>优秀案例</span>
      </a-menu-item>
      <!-- 销售不能看临观处方，销售不能判断结算 -->
      <!-- <a-menu-item key="/activity" v-if="getWorkOrderType !== 3">
        <EyeOutlined class="icon" />
        <span>临观处方</span>
      </a-menu-item> -->
      <a-sub-menu>
        <template #icon><FolderOutlined class="icon" /></template>
        <template #title>健康档案</template>
        <a-menu-item key="/checklist">检查表单</a-menu-item>
        <!-- <a-menu-item key="/healthInfo">健康信息</a-menu-item> -->
      </a-sub-menu>
      <a-sub-menu v-if="isAdmin">
        <template #icon><ProfileOutlined /></template>
        <template #title>内容管理</template>
        <a-menu-item key="/speech">话术管理</a-menu-item>
        <!-- <a-menu-item key="/healthInfo">健康信息</a-menu-item> -->
      </a-sub-menu>
      <a-sub-menu key="/dataCenter">
        <template #icon>
          <PieChartOutlined />
        </template>
        <template #title>数据中心</template>
        <a-menu-item key="/performanceData">绩效数据统计</a-menu-item>
        <a-menu-item key="/salesData">销售提成统计</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/alarmReminder" v-if="isAdmin">
        <template #icon>
          <AppstoreOutlined class="icon" />
        </template>
        <span>预警提醒</span>
        <a-badge :dot="unProcessAlarmDot"></a-badge>
      </a-menu-item>
    </a-menu>
    <div class="the-nav_footer">
      <a-button block class="button" type="text" @click="toggleOpen">
        <MenuUnfoldOutlined v-if="!isOpen" />
        <MenuFoldOutlined v-else />
      </a-button>
    </div>
  </div>
</template>
<script setup>
import {
  CommentOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  FolderOutlined,
  ProfileOutlined,
  PieChartOutlined,
  PhoneOutlined,
  UserDeleteOutlined,
  ContainerOutlined
} from '@ant-design/icons-vue'
import { computed, watch, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { getPermission, getMessageRecallSettings } from '@/api/login'

//用户ERP ID
const ucUserId = computed(() => store.getters.userInfo.ucUserId)
//判断用户是否有管理权限
const isAdmin = ref(false)
// 处理中的未读数量
const pocessingUnReadNum = computed(() => !!store.state.workOrder.processingUnReadCount)
const hasunProcesslDot = computed(() => !!store.state.tccc.unProcessCallNum)
const unProcessAlarmDot = computed(() => store.state.alarm.unProcessAlarmDot)
// 点击某一个菜单栏
const route = useRoute()
const router = useRouter()
// const handleMenu = ({ key }) => router.push(key)
const handleMenu = ({ key }) => {
  store.dispatch('tccc/getCallunProcessedCount')
  store.dispatch('alarm/getUnProcessAlarmReadFlag')
  router.push(key)
}
const selectedKeys = computed(() => [route.path])
const activePath = ref()
watch(selectedKeys, router => (activePath.value = router), { immediate: true })
// 菜单栏状态
const store = useStore()
const isLarge = computed(() => store.state.app.screen === 'large')
const isOpen = computed(() => store.state.app.sidebarStatus)
// 判断此账号获得的工单类型 1:医助医生 2:测试医助 3:BD医助'
// const getWorkOrderType = computed(() => store.state.user.userInfo.workOrderType)
function toggleOpen() {
  // 最小屏幕能够操作
  if (!isLarge.value) return
  store.commit('app/TOGGLE_SIDEBAR', !isOpen.value)
}
const hasDot = computed(() => {
  let has = false
  // 不在工作台时才会判断是否有红点
  if (route.path !== '/workplace') {
    has = pocessingUnReadNum.value
  }
  return has
})

//判断登录用户是否是管理权限
const getMenuPermission = () => {
  getPermission().then((res = []) => {
    isAdmin.value = res.includes(`${ucUserId.value}`)
    store.commit('user/SET_ISADMIN_STATUS', isAdmin.value)
  })
}
// 获取IM消息的撤回配置
const getIMConfig = () => {
  getMessageRecallSettings().then((res = []) => {
    // res[3].messageRecallTime = 24 * 60 * 60 * 1000
    const data = res.find(it => it.serverType === 4) || {}
    store.commit('user/SET_IM_CONFIG', data)
  })
}
onMounted(() => {
  getMenuPermission()
  getIMConfig()
})
</script>
<style lang="scss" scoped>
.the-nav {
  display: flex;
  flex-direction: column;
  height: 100%;

  .logo {
    background: #001529;
    height: 48px;
    line-height: 48px;

    &-img {
      vertical-align: middle;
      display: inline-block;
      height: 32px;
      margin-left: 20px;
    }
  }

  .menu {
    flex-grow: 2;
    border-right: none;
    // 菜单栏文字
    ::v-deep(.ant-menu-item) {
      margin: 8px 0;
    }
    height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
